var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('div',{staticClass:"mode15-box relative"},[_c('div',{staticClass:"mo15-content"},[_c('div',{staticClass:"content-desc",domProps:{"innerHTML":_vm._s(_vm.changeTarget(_vm.$utils.lang_data(_vm.lang, _vm.item.list[0] && _vm.item.list[0], "langInfoObj")?.desc))}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }